<template>
   <div class="box" :style="`height:${boxHeight}px`">
      <div class="left">
         <!-- 左上角申请信息 -->
         <el-form class="leftTopForm" :model="sendDataInfo.leftTopObj" label-width="100px">
            <el-card class="box-card" style="margin-top: 10px;">
               <el-tag size="mini">申请信息</el-tag>
               <el-form-item label="申请部门">
                  <label slot="label" :style="$common.labelStyle('申请部门')" v-html="$common.htmlLabel('申请部门:')"></label>
                  <span class="content">{{ sendDataInfo.leftTopObj.depName }}</span>
               </el-form-item>
               <el-form-item label="申请人">
                  <label slot="label" :style="$common.labelStyle('申请人')" v-html="$common.htmlLabel('申请人:')"></label>
                  <span class="content">{{ sendDataInfo.leftTopObj.opmName }}</span>
               </el-form-item>
               <el-form-item label="申请原因">
                  <label slot="label" :style="$common.labelStyle('申请原因')" v-html="$common.htmlLabel('申请原因:')"></label>
                  <span class="content">{{ sendDataInfo.leftTopObj.applyReason }}</span>
               </el-form-item>
               <el-form-item label="修改备注">
                  <label slot="label" :style="$common.labelStyle('修改备注')" v-html="$common.htmlLabel('修改备注:')"></label>
                  <span class="content">{{ sendDataInfo.leftTopObj.remark }}</span>
               </el-form-item>
            </el-card>
            <el-card class="box-card" style="margin-top: 10px;">
               <el-tag size="mini" v-if="sendDataInfo.leftTopObj.gchmType == 0">商品信息</el-tag>
               <el-tag size="mini" v-else-if="sendDataInfo.leftTopObj.gchmType == 1">供应商信息</el-tag>
               <el-tag size="mini" v-else-if="sendDataInfo.leftTopObj.gchmType == 2">客户信息</el-tag>
               <div v-if="sendDataInfo.leftTopObj.gchmType == 0">
                  <el-form-item label="商品编号">
                     <label slot="label" :style="$common.labelStyle('商品编号')"
                        v-html="$common.htmlLabel('商品编号:')"></label>
                     <span class="content">{{ sendDataInfo.leftTopObj.chanCode }}</span>
                  </el-form-item>
                  <el-form-item label="商品名称">
                     <label slot="label" :style="$common.labelStyle('商品名称')"
                        v-html="$common.htmlLabel('商品名称:')"></label>
                     <span class="content">{{ sendDataInfo.leftTopObj.chanName }}</span>
                  </el-form-item>
                  <el-form-item label="规格">
                     <label slot="label" :style="$common.labelStyle('规格')" v-html="$common.htmlLabel('规格:')"></label>
                     <span class="content">{{ sendDataInfo.leftTopObj.chanInfo }}</span>
                  </el-form-item>
                  <el-form-item label="生产厂商">
                     <label slot="label" :style="$common.labelStyle('生产厂商')"
                        v-html="$common.htmlLabel('生产厂商:')"></label>
                     <span class="content">{{ sendDataInfo.leftTopObj.chanInfo1 }}</span>
                  </el-form-item>
                  <el-form-item label="质量标准编号">
                     <label slot="label" :style="$common.labelStyle('质量标准编号')"
                        v-html="$common.htmlLabel('质量标准编号:')"></label>
                     <span class="content">{{ sendDataInfo.leftTopObj.bgiQuanumber }}</span>
                  </el-form-item>
                  <el-form-item label="产地">
                     <label slot="label" :style="$common.labelStyle('产地')"
                        v-html="$common.htmlLabel('产地:')"></label>
                     <span class="content">{{ sendDataInfo.leftTopObj.placeorigin }}</span>
                  </el-form-item>
               </div>
               <div v-else-if="sendDataInfo.leftTopObj.gchmType == 1">
                  <el-form-item label="供应商名称">
                     <label slot="label" :style="$common.labelStyle('供应商名称')"
                        v-html="$common.htmlLabel('供应商名称:')"></label>
                     <span class="content">{{ sendDataInfo.leftTopObj.chanName }}</span>
                  </el-form-item>
                  <el-form-item label="注册地址">
                     <label slot="label" :style="$common.labelStyle('注册地址')"
                        v-html="$common.htmlLabel('注册地址:')"></label>
                     <span class="content">{{ sendDataInfo.leftTopObj.chanInfo }}</span>
                  </el-form-item>
               </div>
               <div v-else-if="sendDataInfo.leftTopObj.gchmType == 2">
                  <el-form-item label="客户名称">
                     <label slot="label" :style="$common.labelStyle('客户名称')"
                        v-html="$common.htmlLabel('客户名称:')"></label>
                     <span class="content">{{ sendDataInfo.leftTopObj.chanName }}</span>
                  </el-form-item>
                  <el-form-item label="注册地址">
                     <label slot="label" :style="$common.labelStyle('注册地址')"
                        v-html="$common.htmlLabel('注册地址:')"></label>
                     <span class="content">{{ sendDataInfo.leftTopObj.chanInfo }}</span>
                  </el-form-item>
               </div>
               <div v-else-if="sendDataInfo.leftTopObj.gchmType == 3">
                  <el-form-item label="业务员类型">
                     <label slot="label" :style="$common.labelStyle('业务员类型')"
                        v-html="$common.htmlLabel('业务员类型:')"></label>
                     <span class="content" v-if="sendDataInfo.leftTopObj.salesmanType == 1">供应商</span>
                     <span class="content" v-else>客户</span>
                  </el-form-item>
                  <el-form-item label="单位名称">
                     <label slot="label" :style="$common.labelStyle('单位名称')"
                        v-html="$common.htmlLabel('单位名称:')"></label>
                     <span class="content">{{ sendDataInfo.leftTopObj.chanName }}</span>
                  </el-form-item>
               </div>
            </el-card>
         </el-form>
         <!-- 左下角申请的基础信息 -->
         <el-card class="box-card" style="margin-top: 10px;" v-if="sendDataInfo.leftTopObj.gchmType != 3">
            <div style="display: flex;align-items: center;margin-bottom: 10px;">
               <el-tag size="mini">本次修改内容</el-tag>
            </div>
            <el-table :key="tableKey" class="leftBottomTable" ref="leftBottomTable" :data="sendDataInfo.leftBottomList"
               :height="leftBottomHeight" size="mini" border>
               <el-table-column prop="showField" label="字段名称" width="140"></el-table-column>
               <el-table-column prop="oldValue" label="旧值" min-width="180">
                  <template slot-scope="scope">
                     <span v-if="scope.row.entityField == 'bgiManrange'">{{
                        getValue(scope.row.oldValue, scope.row.entityField, scope.row.fieldType,
                           scope.row.formatterContent)
                     }}</span>
                     <span v-else-if="scope.row.entityField == 'bgiProrange'">{{
                        getValue(scope.row.oldValue, scope.row.entityField, scope.row.fieldType,
                           scope.row.formatterContent)
                     }}</span>
                     <span v-else-if="scope.row.entityField == 'bgiTrerange'">{{
                        getValue(scope.row.oldValue, scope.row.entityField, scope.row.fieldType,
                           scope.row.formatterContent)
                     }}</span>
                     <span v-else-if="scope.row.entityField == 'stId'">{{
                        getValue(scope.row.oldValue, scope.row.entityField, scope.row.fieldType,
                           scope.row.formatterContent)
                     }}</span>
                     <span v-else-if="scope.row.fieldType == 'formatter'">{{
                        getValue(scope.row.oldValue, scope.row.entityField, scope.row.fieldType,
                           scope.row.formatterContent)
                     }}</span>
                     <span v-else-if="scope.row.fieldType == 'radio'">{{
                        getValue(scope.row.oldValue, scope.row.entityField, scope.row.fieldType,
                           scope.row.formatterContent)
                     }}</span>
                     <span v-else-if="scope.row.fieldType == 'date'">
                        <span v-if="scope.row.oldValue">
                           {{ $common.getLocalTime(scope.row.oldValue, true) }}
                        </span>
                     </span>
                     <span v-else>{{ scope.row.oldValue }}</span>
                  </template>
               </el-table-column>
               <el-table-column prop="newValue" label="新值" min-width="180">
                  <template slot-scope="scope">
                     <span v-if="scope.row.entityField == 'bgiManrange'">{{
                        getValue(scope.row.newValue, scope.row.entityField, scope.row.fieldType,
                           scope.row.formatterContent)
                     }}</span>
                     <span v-else-if="scope.row.entityField == 'bgiProrange'">{{
                        getValue(scope.row.newValue, scope.row.entityField, scope.row.fieldType,
                           scope.row.formatterContent)
                     }}</span>
                     <span v-else-if="scope.row.entityField == 'bgiTrerange'">{{
                        getValue(scope.row.newValue, scope.row.entityField, scope.row.fieldType,
                           scope.row.formatterContent)
                     }}</span>
                     <span v-else-if="scope.row.entityField == 'stId'">{{
                        getValue(scope.row.newValue, scope.row.entityField, scope.row.fieldType,
                           scope.row.formatterContent)
                     }}</span>
                     <span v-else-if="scope.row.fieldType == 'formatter'">{{
                        getValue(scope.row.newValue, scope.row.entityField, scope.row.fieldType,
                           scope.row.formatterContent)
                     }}</span>
                     <span v-else-if="scope.row.fieldType == 'radio'">{{
                        getValue(scope.row.newValue, scope.row.entityField,
                           scope.row.fieldType, scope.row.formatterContent)
                        }}</span>
                     <span v-else-if="scope.row.fieldType == 'date'">
                        <span v-if="scope.row.newValue">
                           {{ $common.getLocalTime(scope.row.newValue, true) }}
                        </span>
                     </span>
                     <span v-else>{{ scope.row.newValue }}</span>
                  </template>
               </el-table-column>
            </el-table>
         </el-card>
      </div>
      <div class="right" :class="{ 'rightBox': sendDataInfo.leftTopObj.gchmType == 2 }"
         :style="`width:${rightWidth}px;height:${rightBoxHeight}px`">
         <el-card class="box-card" style="margin-top: 10px;">
            <div style="display: flex;align-items: center;margin-bottom: 10px;">
               <el-tag size="mini">原证照信息</el-tag>
               <p style="display: flex;align-items: center;margin-left: 10px; color: red;font-size: 15px;">
                  <span>新增证照：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #ffedb7;margin-right: 10px;"></span>
                  <span>修改证照：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #c9ffb7;margin-right: 10px;"></span>
                  <span>删除证照：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #ffafaf;margin-right: 10px;"></span>
               </p>
            </div>
            <el-table :data="sendDataInfo.rightTopList" :height="rightHeight / 2" size="mini" border
               :row-style="rowStyle1">
               <el-table-column
                  :show-overflow-tooltip="formOneValue.entityField == 'uploadVoList' || formOneValue.entityField == 'filePath' ? false : true"
                  v-for="(formOneValue, index) in fieldJson" :key="index" :prop="formOneValue.entityField"
                  :label="formOneValue.showField" :min-width="formOneValue.fieldWeight">
                  <template slot-scope="scope">
                     <span v-if="formOneValue.fieldType == 'date'">
                        {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                     </span>
                     <div v-else-if="formOneValue.entityField == 'uploadVoList'" class="uploadList">
                        <cusImage class="image" v-for="(val, key) in scope.row.uploadVoList" :key="key"
                           style="width: 30px; height: 30px;margin-top: 5px;" :src="`${imgUrl}/${val.fileUrl}`"
                           :preview-src-list="scope.row.uploadVoList.map(item => `${imgUrl}/${item.fileUrl}`)">
                        </cusImage>
                     </div>
                     <div v-else-if="formOneValue.entityField == 'filePath'">
                        <div class="uploadList" v-if="scope.row.filePath">
                           <cusImage class="image" v-for="(val, key) in scope.row.filePath.split(',')" :key="key"
                              style="width: 30px; height: 30px;margin-top: 5px;" :src="`${imgUrl}/${val}`"
                              :preview-src-list="scope.row.filePath.split(',').map(item => `${imgUrl}/${item}`)">
                           </cusImage>
                        </div>
                        <span v-else></span>
                     </div>
                     <span v-else-if="formOneValue.entityField == 'isIntercept'">
                        <el-tag size="mini" v-if="scope.row[formOneValue.entityField] == 1">是</el-tag>
                        <el-tag size="mini" type="warning"
                           v-else-if="scope.row[formOneValue.entityField] == 0">否</el-tag>
                     </span>
                     <span v-else-if="formOneValue.entityField == 'terType'">
                        <el-tag size="mini" v-if="scope.row[formOneValue.entityField] == 1">单品委托</el-tag>
                        <el-tag size="mini" type="success"
                           v-else-if="scope.row[formOneValue.entityField] == 0">全品委托</el-tag>
                     </span>
                     <span v-else-if="formOneValue.entityField == 'terScope'">
                        <el-tag size="mini" v-if="scope.row[formOneValue.entityField] == 2">器械</el-tag>
                        <el-tag size="mini" v-else-if="scope.row[formOneValue.entityField] == 1">药品</el-tag>
                        <el-tag size="mini" type="success"
                           v-else-if="scope.row[formOneValue.entityField] == 0">全部</el-tag>
                     </span>
                     <span v-else>
                        {{ scope.row[formOneValue.entityField] }}
                     </span>
                  </template>
               </el-table-column>
               <el-table-column v-if="sendDataInfo.leftTopObj.gchmType == 2" show-overflow-tooltip prop="scope"
                  label="证照范围" min-width="180"></el-table-column>
            </el-table>
         </el-card>
         <el-card class="box-card" style="margin-top: 10px;">
            <div style="display: flex;align-items: center;margin-bottom: 10px;">
               <el-tag size="mini" type="danger">新证照信息</el-tag>
               <p style="display: flex;align-items: center;margin-left: 10px; color: red;font-size: 15px;">
                  <span>新增证照：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #ffedb7;margin-right: 10px;"></span>
                  <span>修改证照：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #c9ffb7;margin-right: 10px;"></span>
                  <span>删除证照：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #ffafaf;margin-right: 10px;"></span>
               </p>
            </div>
            <el-table :data="sendDataInfo.rightBottomList" :height="rightHeight / 2" size="mini" border
               :row-style="rowStyle">
               <el-table-column
                  :show-overflow-tooltip="formOneValue.entityField == 'uploadVoList' || formOneValue.entityField == 'filePath' ? false : true"
                  v-for="(formOneValue, index) in fieldJson" :key="index" :prop="formOneValue.entityField"
                  :label="formOneValue.showField" :min-width="formOneValue.fieldWeight">
                  <template slot-scope="scope">
                     <span v-if="formOneValue.fieldType == 'date'">
                        {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                     </span>
                     <div v-else-if="formOneValue.entityField == 'uploadVoList'" class="uploadList">
                        <cusImage class="image" v-for="(val, key) in scope.row.uploadVoList" :key="key"
                           style="width: 30px; height: 30px;margin-top: 5px;" :src="`${imgUrl}/${val.fileUrl}`"
                           :preview-src-list="scope.row.uploadVoList.map(item => `${imgUrl}/${item.fileUrl}`)">
                        </cusImage>
                     </div>
                     <div v-else-if="formOneValue.entityField == 'filePath'">
                        <div class="uploadList" v-if="scope.row.filePath">
                           <cusImage class="image" v-for="(val, key) in scope.row.filePath.split(',')" :key="key"
                              style="width: 30px; height: 30px;margin-top: 5px;" :src="`${imgUrl}/${val}`"
                              :preview-src-list="scope.row.filePath.split(',').map(item => `${imgUrl}/${item}`)">
                           </cusImage>
                        </div>
                        <span v-else></span>
                     </div>
                     <span v-else-if="formOneValue.entityField == 'isIntercept'">
                        <el-tag size="mini" v-if="scope.row[formOneValue.entityField] == 1">是</el-tag>
                        <el-tag size="mini" type="warning"
                           v-else-if="scope.row[formOneValue.entityField] == 0">否</el-tag>
                     </span>
                     <span v-else-if="formOneValue.entityField == 'terType'">
                        <el-tag size="mini" v-if="scope.row[formOneValue.entityField] == 1">单品委托</el-tag>
                        <el-tag size="mini" type="success"
                           v-else-if="scope.row[formOneValue.entityField] == 0">全品委托</el-tag>
                     </span>
                     <span v-else-if="formOneValue.entityField == 'terScope'">
                        <el-tag size="mini" v-if="scope.row[formOneValue.entityField] == 2">器械</el-tag>
                        <el-tag size="mini" v-else-if="scope.row[formOneValue.entityField] == 1">药品</el-tag>
                        <el-tag size="mini" type="success"
                           v-else-if="scope.row[formOneValue.entityField] == 0">全部</el-tag>
                     </span>
                     <span v-else>
                        {{ scope.row[formOneValue.entityField] }}
                     </span>
                  </template>
               </el-table-column>
               <el-table-column v-if="sendDataInfo.leftTopObj.gchmType == 2" show-overflow-tooltip prop="scope"
                  label="证照范围" min-width="180"></el-table-column>
            </el-table>
         </el-card>
         <el-card v-if="sendDataInfo.leftTopObj.gchmType == 2" class="box-card" style="margin-top: 10px;">
            <div style="display: flex;align-items: center;margin-bottom: 10px;">
               <el-tag size="mini">原客户地址信息</el-tag>
               <p style="display: flex;align-items: center;margin-left: 10px; color: red;font-size: 15px;">
                  <span>新增客户地址：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #ffedb7;margin-right: 10px;"></span>
                  <span>修改客户地址：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #c9ffb7;margin-right: 10px;"></span>
                  <span>删除客户地址：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #ffafaf;margin-right: 10px;"></span>
               </p>
            </div>
            <el-table :data="sendDataInfo.rightTopAddressList" :height="300" size="mini" border :row-style="rowStyle2">
               <el-table-column
                  :show-overflow-tooltip="formOneValue.entityField == 'uploadVoList' || formOneValue.entityField == 'filePath' ? false : true"
                  v-for="(formOneValue, index) in fieldJson1" :key="index" :prop="formOneValue.entityField"
                  :label="formOneValue.showField" :min-width="formOneValue.fieldWeight">
                  <template slot-scope="scope">
                     <span v-if="formOneValue.entityField == 'isDefault'">
                        <el-tag size="mini" v-if="scope.row[formOneValue.entityField] == 1">是</el-tag>
                        <el-tag size="mini" type="warning"
                           v-else-if="scope.row[formOneValue.entityField] == 0">否</el-tag>
                     </span>
                     <span v-else-if="formOneValue.entityField == 'areaCode'">
                        {{ scope.row.caiProvince }} {{ scope.row.caiCity }} {{ scope.row.caiArea }}
                     </span>
                     <span v-else>
                        {{ scope.row[formOneValue.entityField] }}
                     </span>
                  </template>
               </el-table-column>
            </el-table>
         </el-card>
         <el-card v-if="sendDataInfo.leftTopObj.gchmType == 2" class="box-card" style="margin-top: 10px;">
            <div style="display: flex;align-items: center;margin-bottom: 10px;">
               <el-tag size="mini" type="danger">新客户地址信息</el-tag>
               <p style="display: flex;align-items: center;margin-left: 10px; color: red;font-size: 15px;">
                  <span>新增客户地址：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #ffedb7;margin-right: 10px;"></span>
                  <span>修改客户地址：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #c9ffb7;margin-right: 10px;"></span>
                  <span>删除客户地址：</span><span
                     style="display: inline-block;height: 15px;width: 30px;background-color: #ffafaf;margin-right: 10px;"></span>
               </p>
            </div>
            <el-table :data="sendDataInfo.rightBottomAddressList" :height="300" size="mini" border
               :row-style="rowStyle3">
               <el-table-column
                  :show-overflow-tooltip="formOneValue.entityField == 'uploadVoList' || formOneValue.entityField == 'filePath' ? false : true"
                  v-for="(formOneValue, index) in fieldJson1" :key="index" :prop="formOneValue.entityField"
                  :label="formOneValue.showField" :min-width="formOneValue.fieldWeight">
                  <template slot-scope="scope">
                     <span v-if="formOneValue.entityField == 'isDefault'">
                        <el-tag size="mini" v-if="scope.row[formOneValue.entityField] == 1">是</el-tag>
                        <el-tag size="mini" type="warning"
                           v-else-if="scope.row[formOneValue.entityField] == 0">否</el-tag>
                     </span>
                     <span v-else-if="formOneValue.entityField == 'areaCode'">
                        {{ scope.row.caiProvince }} {{ scope.row.caiCity }} {{ scope.row.caiArea }}
                     </span>
                     <span v-else>
                        {{ scope.row[formOneValue.entityField] }}
                     </span>
                  </template>
               </el-table-column>
            </el-table>
         </el-card>
      </div>
      <div class="foot">
         <el-button v-if="$common.checkIsPrint()" type="primary" @click="showPrintPlan">打印</el-button>
      </div>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
var fieldJson0 = [
   {
      entityField: "lityId",
      showField: "证照类型",
      fieldWeight: 150,
      fieldType: "string"
   },
   {
      entityField: "tername",
      showField: "证照名称",
      fieldWeight: 150,
      fieldType: "string"
   },
   {
      entityField: "ternumber",
      showField: "证照号",
      fieldWeight: 150,
      fieldType: "string"
   },
   {
      entityField: "reoffice",
      showField: "发证机关",
      fieldWeight: 150,
      fieldType: "string"
   },
   {
      entityField: "redate",
      showField: "发证日期",
      fieldWeight: 150,
      fieldType: "date"
   },
   {
      entityField: "tervalidity",
      showField: "证照有效期",
      fieldWeight: 150,
      fieldType: "date"
   },
   {
      entityField: "remark",
      showField: "备注",
      fieldWeight: 120,
      fieldType: "string"
   },
   {
      entityField: "isIntercept",
      showField: "是否拦截",
      fieldWeight: 80,
      fieldType: "formatter",
      formatterContent: [
         {
            key: 0,
            value: "否"
         },
         {
            key: 1,
            value: "是"
         }
      ]
   },
   {
      entityField: "uploadVoList",
      showField: "证照附件信息",
      fieldWeight: 230,
      fieldType: "string"
   },
]
var fieldJson1 = [
   {
      entityField: "salesName",
      showField: "业务员名称",
      fieldWeight: 150,
      fieldType: "string"
   },
   {
      entityField: "geogRest",
      showField: "地域限制",
      fieldWeight: 150,
      fieldType: "string"
   },
   {
      entityField: "salesSex",
      showField: "性别",
      fieldWeight: 100,
      fieldType: "string"
   },
   {
      entityField: "phone",
      showField: "电话",
      fieldWeight: 150,
      fieldType: "string"
   },
   {
      entityField: "salesNumber",
      showField: "身份证号",
      fieldWeight: 200,
      fieldType: "string"
   },
   {
      entityField: "numberValidity",
      showField: "身份证有效期",
      fieldWeight: 150,
      fieldType: "date"
   },
   {
      entityField: "remark",
      showField: "备注",
      fieldWeight: 120,
      fieldType: "string"
   },
   {
      entityField: "terType",
      showField: "委托书类型",
      fieldWeight: 120,
      fieldType: "string"
   },
   {
      entityField: "terName",
      showField: "委托书名称",
      fieldWeight: 150,
   },
   {
      entityField: "terValidity",
      showField: "委托书有效期",
      fieldWeight: 150,
      fieldType: "date"
   },
   {
      entityField: "filePath",
      showField: "委托书附件",
      fieldWeight: 230,
      fieldType: "string"
   },
   {
      entityField: "terScope",
      showField: "委托范围",
      fieldWeight: 230,
      fieldType: "formatter",
      formatterContent: [
         {
            key: 0,
            value: "全部"
         },
         {
            key: 1,
            value: "药品"
         },
         {
            key: 2,
            value: "器械"
         }
      ]
   },
]
var fieldJson2 = [
   {
      entityField: "areaCode",
      showField: "省市区",
      fieldWeight: 250,
      fieldType: "string"
   },
   {
      entityField: "caiAddress",
      showField: "地址",
      fieldWeight: 150,
      fieldType: "string"
   },
   {
      entityField: "caiLinker",
      showField: "联系人",
      fieldWeight: 150,
      fieldType: "string"
   },
   {
      entityField: "caiTelnumber",
      showField: "电话",
      fieldWeight: 150,
      fieldType: "string"
   },
   {
      entityField: "remark",
      showField: "备注",
      fieldWeight: 150,
      fieldType: "string"
   },
   {
      entityField: "isDefault",
      showField: "是否默认",
      fieldWeight: 150,
      fieldType: "formatter",
      formatterContent: "[{\"key\":0,\"value\":\"否\"},{\"key\":1,\"value\":\"是\"}]"
   }, {
      entityField: "caiPostcode",
      showField: "邮编",
      fieldWeight: 150,
      fieldType: "string"
   },
]
import SearchScheme from "../byComponents/SearchScheme.vue";
import {
   provinceAndCityData,
   regionData,
   provinceAndCityDataPlus,
   regionDataPlus,
   CodeToText,
   TextToCode,
} from "element-china-area-data";
export default {
   name: "informationSee",
   components: { SearchScheme },
   props: ['actionData'],
   data() {
      return {
         fieldJson: fieldJson0,
         fieldJson1: fieldJson2,
         imgUrl: window.global_config.BASE_IMG_URL,
         sendDataInfo: {
            leftTopObj: {
               depName: "",
               opmName: "",
               applyReason: "",
               remark: "",
               gchmType: 0,//0商品 1供应商 2客户
               businessId: "",
               chanName: "",
               chanCode: "",
               chanInfo: "",
               chanInfo1: "",
               salesmanType: 0, //1供应商 0客户
               placeorigin: "",//产地
               bgiQuanumber: "",//质量标准编号
            },
            leftBottomList: [],
            rightTopList: [],
            rightBottomList: [],
            rightTopAddressList: [],//原客户地址
            rightBottomAddressList: [],//新客户地址
         },
         dictionariesData: {},//字典（商品）
         rangeObj: {}, //范围对象
         storageRoomList: [],//库房
         cmManrangeIds: [],//经营范围(客户)
         cmTrerangeIds: [],//诊疗范围(客户)
         geogRestData: [],//地域限制列表（委托书）
         boxHeight: 1000,
         rightBoxHeight: 1000,
         leftBottomHeight: 300,
         rightHeight: 900,
         rightWidth: 700,
         tableKey: 0,
      }
   },
   created() { this.openBox() },
   methods: {
      getValue(val, type, fieldType, arr) {
         var str = ""
         if (type == 'stId') {
            if (this.storageRoomList && this.storageRoomList.length > 0) {
               this.storageRoomList.forEach(item => {
                  if (item.stId == val) {
                     str = item.stName
                  }
               })
            }
         } else if (type == 'bgpUnitmeasurement') {
            if (this.dictionariesData.BZDW) {
               this.dictionariesData.BZDW.forEach(item => {
                  if (item.diValue == val) {
                     str = item.diName
                  }
               })
            }
         } else if (type == 'largePackage') {
            if (this.dictionariesData.DBZ) {
               this.dictionariesData.DBZ.forEach(item => {
                  if (item.diValue == val) {
                     str = item.diName
                  }
               })
            }
         } else if (type == 'bgiCurtype') {
            if (this.dictionariesData.yhlx) {
               this.dictionariesData.yhlx.forEach(item => {
                  if (item.diValue == val) {
                     str = item.diName
                  }
               })
            }
         } else if (type == 'bgiDromodel') {
            if (this.dictionariesData.jx) {
               this.dictionariesData.jx.forEach(item => {
                  if (item.diValue == val) {
                     str = item.diName
                  }
               })
            }
         } else if (type == 'bgiPretype') {
            if (this.dictionariesData.cflx) {
               this.dictionariesData.cflx.forEach(item => {
                  if (item.diValue == val) {
                     str = item.diName
                  }
               })
            }
         } else if (type == 'bgiQuatype') {
            if (this.dictionariesData.zlbz) {
               this.dictionariesData.zlbz.forEach(item => {
                  if (item.diValue == val) {
                     str = item.diName
                  }
               })
            }
         } else if (type == 'bgiStocondition') {
            if (this.dictionariesData.cctj) {
               this.dictionariesData.cctj.forEach(item => {
                  if (item.diValue == val) {
                     str = item.diName
                  }
               })
            }
         } else if (type == 'transMode') {
            if (this.dictionariesData.YSLX) {
               this.dictionariesData.YSLX.forEach(item => {
                  if (item.diValue == val) {
                     str = item.diName
                  }
               })
            }
         } else if (type == 'bgiProrange') {
            if (this.rangeObj.p) {
               this.rangeObj.p.forEach(item => {
                  if (item.discId == val) {
                     str = item.scopeName
                  }
               })
            }
         } else if (type == 'bgiManrange') {
            if (this.rangeObj.m) {
               this.rangeObj.m.forEach(item => {
                  if (item.discId == val) {
                     str = item.scopeName
                  }
               })
            }
         } else if (type == 'bgiTrerange') {
            if (this.rangeObj.z) {
               this.rangeObj.z.forEach(item => {
                  if (item.discId == val) {
                     str = item.scopeName
                  }
               })
            }
         } else if (type == 'financialName') {
            if (this.dictionariesData.cwfl) {
               this.dictionariesData.cwfl.forEach(item => {
                  if (item.diValue == val) {
                     str = item.diName
                  }
               })
            }
         } else if (type == 'geogRest') {
            if (this.geogRestData) {
               this.geogRestData.forEach(item => {
                  if (item.diValue == val) {
                     str = item.diName
                  }
               })
            }
         } else if (type == 'bgiType' || fieldType == 'formatter' || fieldType == 'radio') {
            if (arr != null) {

               arr.forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value == val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key == val) {
                     str = item.value
                  }
               })
               if (str === "" || str == null || str == undefined) {
                  str = val
               }
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      showPrintPlan() { // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
         } else {
            return
         }
      },
      async getFrom() {
         var sendData = {
            type: this.sendDataInfo.leftTopObj.gchmType,
            businessId: this.sendDataInfo.leftTopObj.businessId,
         }
         var manrangeIdIndex = 0
         var trerangeIdindex = 0
         var prorangeIdindex = 0
         var responseData = await this.$http.getFormByType(sendData);
         this.sendDataInfo.leftBottomList.forEach((item, index) => {
            if (item.entityField == 'areaCode') {
               var strnew = ""
               var strnew1 = ""
               var strold = ""
               var strold1 = ""
               var oldValue = ""
               var newValue = ""
               if (item.newValue != '' && item.newValue != null) {
                  strnew = item.newValue.substr(0, 2) + '0000'
                  strnew1 = item.newValue.substr(0, 4) + '00'
                  for (const key in CodeToText) {
                     if (key == strnew) {
                        newValue = CodeToText[key]
                     }
                     if (key == strnew1) {
                        newValue = newValue + '/' + CodeToText[key]
                     }
                     if (key == item.newValue) {
                        newValue = newValue + '/' + CodeToText[key]
                     }
                  }
                  item.newValue = newValue
               }
               if (item.oldValue != '' && item.oldValue != null) {
                  strold = item.oldValue.substr(0, 2) + '0000'
                  strold1 = item.oldValue.substr(0, 4) + "00"
                  for (const key in CodeToText) {
                     if (key == strold) {
                        oldValue = CodeToText[key]
                     }
                     if (key == strold1) {
                        oldValue = oldValue + '/' + CodeToText[key]
                     }
                     if (key == item.oldValue) {
                        oldValue = oldValue + '/' + CodeToText[key]
                     }
                  }
                  item.oldValue = oldValue
               }
            }
            if (item.entityField == 'cmManrange' || item.entityField == 'smManrange') {
               manrangeIdIndex = index
               this.manrangeIdsNew = item.newValue && item.newValue != null ? item.newValue.split(",") : []
               this.manrangeIdsOld = item.oldValue && item.oldValue != null ? item.oldValue.split(",") : []
            }
            if (item.entityField == 'cmTrerange') {
               trerangeIdindex = index
               this.trerangeIdsNew = item.newValue && item.newValue != null ? item.newValue.split(",") : []
               this.trerangeIdsOld = item.oldValue && item.oldValue != null ? item.oldValue.split(",") : []
            }
            if (item.entityField == 'smProrange') {
               prorangeIdindex = index
               this.prorangeIdNew = item.newValue && item.newValue != null ? item.newValue.split(",") : []
               this.prorangeIdsOld = item.oldValue && item.oldValue != null ? item.oldValue.split(",") : []
            }
            let row = responseData.result.filter(val => item.entityField == val.entityField)
            if (row.length > 0) {
               this.$set(item, 'showField', row[0].showField)
               this.$set(item, 'fieldType', row[0].fieldType)
               if (row[0].formatterContent) {
                  this.$set(item, 'formatterContent', JSON.parse(row[0].formatterContent))
               } else {
                  this.$set(item, 'formatterContent', null)
               }
            } else {
               this.$set(item, 'fieldType', 'string')
               this.$set(item, 'formatterContent', null)
            }
         })
         if (this.sendDataInfo.leftTopObj.gchmType == 0) {
            this.getAllStorageRoom()
         }
         console.log(this.sendDataInfo.leftBottomList, "测试");
         this.getPartDictionariesData()
         this.getQueryScopeByType(0).then((res) => {
            if (this.sendDataInfo.leftTopObj.gchmType == 0) {
               this.$set(this.rangeObj, "p", res);
            }
            let value1 = [];
            let value2 = [];
            if (this.prorangeIdsOld && this.prorangeIdsOld.length) {
               this.prorangeIdsOld.forEach((val) => {
                  if (res.length > 0) {
                     if (res.filter((item) => val == item.discId).length > 0) {
                        value1.push(res.filter((item) => val == item.discId)[0].scopeName);
                     }
                  }
               });
               this.sendDataInfo.leftBottomList[prorangeIdindex].oldValue = value1.toString();
            }
            if (this.prorangeIdNew && this.prorangeIdNew.length) {
               this.prorangeIdNew.forEach((val) => {
                  if (res.length > 0) {
                     if (res.filter((item) => val == item.discId).length > 0) {
                        value2.push(res.filter((item) => val == item.discId)[0].scopeName);
                     }
                  }
               });
               this.sendDataInfo.leftBottomList[prorangeIdindex].newValue = value2.toString();
            }
         });
         this.getQueryScopeByType(1).then((res) => {
            if (this.sendDataInfo.leftTopObj.gchmType == 0) {
               this.$set(this.rangeObj, "m", res);
            }
            let value1 = [];
            let value2 = [];
            if (this.manrangeIdsOld && this.manrangeIdsOld.length) {
               this.manrangeIdsOld.forEach((val) => {
                  if (res.length > 0) {
                     if (res.filter((item) => val == item.discId).length > 0) {
                        value1.push(res.filter((item) => val == item.discId)[0].scopeName);
                     }
                  }
               });
               this.sendDataInfo.leftBottomList[manrangeIdIndex].oldValue = value1.toString();
            }
            if (this.manrangeIdsNew && this.manrangeIdsNew.length) {
               this.manrangeIdsNew.forEach((val) => {
                  if (res.length > 0) {
                     if (res.filter((item) => val == item.discId).length > 0) {
                        value2.push(res.filter((item) => val == item.discId)[0].scopeName);
                     }
                  }
               });
               this.sendDataInfo.leftBottomList[manrangeIdIndex].newValue = value2.toString();
            }
         });
         this.getQueryScopeByTypeZhenLiao(2).then((res) => {
            if (this.sendDataInfo.leftTopObj.gchmType == 0) {
               this.$set(this.rangeObj, "z", res);
            }
            let value1 = [];
            let value2 = [];
            if (this.trerangeIdsOld && this.trerangeIdsOld.length) {
               this.trerangeIdsOld.forEach((val) => {
                  if (res.length > 0) {
                     if (res.filter((item) => val == item.discId).length > 0) {
                        value1.push(res.filter((item) => val == item.discId)[0].scopeName);
                     }
                  }
               });
               this.sendDataInfo.leftBottomList[trerangeIdindex].oldValue = value1.toString();
            }
            if (this.trerangeIdsNew && this.trerangeIdsNew.length) {
               this.trerangeIdsNew.forEach((val) => {
                  if (res.length > 0) {
                     if (res.filter((item) => val == item.discId).length > 0) {
                        value2.push(res.filter((item) => val == item.discId)[0].scopeName);
                     }
                  }
               });
               this.sendDataInfo.leftBottomList[trerangeIdindex].newValue = value2.toString();
            }

         });

      },
      openBox() {
         window.addEventListener('resize', this.heightChange);
         var dataInfo = {}
         if (this.actionData.oldData) {
            dataInfo = JSON.parse(JSON.stringify(this.actionData.oldData))
            for (const key in this.sendDataInfo.leftTopObj) {
               this.sendDataInfo.leftTopObj[key] = dataInfo[key];
            }
            this.sendDataInfo.leftBottomList = []
            if (dataInfo.detailList != undefined && dataInfo.detailList != "" && dataInfo.detailList != null && dataInfo.detailList.length > 0) {
               dataInfo.detailList.forEach(item => {
                  if (item.isShow == 1) {
                     this.sendDataInfo.leftBottomList.push(item)
                  }
               })
               this.getFrom()
            }
            if (this.sendDataInfo.leftTopObj.gchmType != 3) {  //0商品 1供应商 2客户
               this.fieldJson = fieldJson0
               if (dataInfo.newDetailList != undefined && dataInfo.newDetailList != "" && dataInfo.newDetailList != null) {
                  dataInfo.newDetailList.forEach(item => {
                     delete item.lnId
                     delete item.createTime
                     item.uploadVoList.forEach(items => {
                        delete items.bgmName
                        delete items.busType
                        delete items.codingNum
                        delete items.createTime
                        delete items.creater
                        delete items.createrName
                        delete items.fileId
                        delete items.fileName
                        delete items.fileType
                        delete items.type
                     })
                  })
                  this.sendDataInfo.rightBottomList = dataInfo.newDetailList
               } else {
                  this.sendDataInfo.rightBottomList = []
               }
               if (dataInfo.oldDetailList != undefined && dataInfo.oldDetailList != "" && dataInfo.oldDetailList != null) {
                  dataInfo.oldDetailList.forEach(item => {
                     delete item.loId
                     delete item.createTime
                     item.uploadVoList.forEach(items => {
                        delete items.bgmName
                        delete items.busType
                        delete items.codingNum
                        delete items.createTime
                        delete items.creater
                        delete items.createrName
                        delete items.fileId
                        delete items.fileName
                        delete items.fileType
                        delete items.type
                     })
                  })
                  this.sendDataInfo.rightTopList = dataInfo.oldDetailList
               } else {
                  this.sendDataInfo.rightTopList = []
               }
               if (dataInfo.newDescibCusAddress != undefined && dataInfo.newDescibCusAddress != "" && dataInfo.newDescibCusAddress != null) {
                  dataInfo.newDescibCusAddress.forEach(item => {
                     delete item.areaCode
                     delete item.id
                     delete item.caiUpdatetime
                  })
                  this.sendDataInfo.rightBottomAddressList = dataInfo.newDescibCusAddress
               } else {
                  this.sendDataInfo.rightBottomAddressList = []
               }
               if (dataInfo.oldDescibCusAddress != undefined && dataInfo.oldDescibCusAddress != "" && dataInfo.oldDescibCusAddress != null) {
                  dataInfo.oldDescibCusAddress.forEach(item => {
                     delete item.areaCode
                     delete item.id
                     delete item.caiUpdatetime
                  })
                  this.sendDataInfo.rightTopAddressList = dataInfo.oldDescibCusAddress
               } else {
                  this.sendDataInfo.rightTopAddressList = []
               }
            } else {
               this.fieldJson = fieldJson1
               if (dataInfo.oldauthLetterChanges != undefined && dataInfo.oldauthLetterChanges != "" && dataInfo.oldauthLetterChanges != null) {
                  dataInfo.oldauthLetterChanges.forEach(item => {
                     delete item.gchmType
                     delete item.id
                  })
                  this.sendDataInfo.rightTopList = dataInfo.oldauthLetterChanges
               } else {
                  this.sendDataInfo.rightTopList = []
               }
               if (dataInfo.newauthLetterChanges != undefined && dataInfo.newauthLetterChanges != "" && dataInfo.newauthLetterChanges != null) {
                  dataInfo.newauthLetterChanges.forEach(item => {
                     delete item.gchmType
                     delete item.id
                  })
                  this.sendDataInfo.rightBottomList = dataInfo.newauthLetterChanges
               } else {
                  this.sendDataInfo.rightBottomList = []
               }
               //console.log(this.sendDataInfo.rightBottomList[3], this.sendDataInfo.rightTopList[3]);
               //console.log(JSON.stringify(this.sendDataInfo.rightTopList[3]));
               //console.log(JSON.stringify(this.sendDataInfo.rightBottomList[3]));


            }
         }
         this.$nextTick(() => {
            this.heightChange()
         })
      },
      // 获取字典数据
      getPartDictionariesData() {
         this.$http.getPartDictionariesData({
            ids: [14, 10, 9, 25, 11, 13, 5, 30, 39, 41, 42, 43, 58],
         }).then(responseData => {
            if (responseData.status == 200) {
               this.dictionariesData = responseData.result;
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         })
      },
      // 获取所有可用库房列表
      getAllStorageRoom() {
         this.$http.getGspStorageRoom().then(responseData => {
            if (responseData.status == 200) {
               this.storageRoomList = responseData.result;
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         });

      },
      //获取生产/经营范围
      async getQueryScopeByType(type) {
         let ormId = sessionStorage.getItem("ormId");
         let params = {
            type: type,
            ormId: ormId,
         };
         let responseData
         if (this.sendDataInfo.leftTopObj.gchmType == 0) {
            responseData = await this.$http.queryScopeByTypeByOrm(params);
         } else {
            responseData = await this.$http.queryScopeByType(params);
         }
         if (responseData.status == 200) {
            return responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //获取诊疗范围
      async getQueryScopeByTypeZhenLiao(type) {
         let ormId = sessionStorage.getItem("ormId");
         let params = {
            type: type,
            ormId: ormId,
         };
         //type 范围类型0.生产范围1.经营范围
         let responseData = await this.$http.queryScopeByType(params);
         if (responseData.status == 200) {
            return responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //获取地域限制列表
      async getPartDictionariesData() {
         let responseData = await this.$http.getPartDictionariesData({
            ids: [1, 44],
         });
         if (responseData.status == 200) {
            this.geogRestData = responseData.result.dyxz;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      rowStyle1({ row, rowIndex }) {
         let rowBackground = {}
         if (row.type == 2) {
            rowBackground.backgroundColor = "#ffafaf"
         } else {
            rowBackground.backgroundColor = "#ffffff"
         }
         return rowBackground
      },
      // 选中行底色逻辑
      rowStyle({ row, rowIndex }) {
         var flag = false
         var flag1 = false
         let rowBackground = {}
         this.sendDataInfo.rightTopList.forEach((item,index) => {
            if (this.sendDataInfo.leftTopObj.gchmType != 3) {
               if (JSON.stringify(row) != JSON.stringify(item) && row.lityId == item.lityId && !flag) {
                  flag = true
               }
               if (row.type == 1 && !flag1) {
                  flag1 = true
               }
            } else {
               if (JSON.stringify(row) != JSON.stringify(item) && row.scsId == item.scsId && !flag) {
                  flag = true
               }
               if (row.type == 1 && !flag1) {
                  flag1 = true
               }
            }
         })
         if (flag) {
            rowBackground.backgroundColor = "#c9ffb7"
         } else if (flag1) {
            rowBackground.backgroundColor = "#ffedb7"
         } else {
            rowBackground.backgroundColor = "#ffffff"
         }
         return rowBackground
      },
      rowStyle2({ row, rowIndex }) {
         let rowBackground = {}
         if (row.type == 2) {
            rowBackground.backgroundColor = "#ffafaf"
         } else {
            rowBackground.backgroundColor = "#ffffff"
         }
         return rowBackground
      },
      // 选中行底色逻辑
      rowStyle3({ row, rowIndex }) {
         var flag = false
         var flag1 = false
         let rowBackground = {}
         this.sendDataInfo.rightTopAddressList.forEach(item => {
            if (JSON.stringify(row) != JSON.stringify(item) && row.caiId == item.caiId && !flag) {
               flag = true
            }
            if (row.type == 1 && !flag1) {
               flag1 = true
            }

         })
         if (flag) {
            rowBackground.backgroundColor = "#c9ffb7"
         } else if (flag1) {
            rowBackground.backgroundColor = "#ffedb7"
         } else {
            rowBackground.backgroundColor = "#ffffff"
         }
         return rowBackground
      },
      heightChange() {
         var totalHeight = document.documentElement.querySelector(".el-drawer__body").clientHeight
         //顶部按钮
         var headHeight = 0
         var headTabHeight = 0
         var floorHeight = 0
         if (document.documentElement.querySelector(".el-drawer__body").querySelector(".btns")) {
            headHeight = document.documentElement.querySelector(".el-drawer__body").querySelector(".btns").clientHeight
         }
         if (document.documentElement.querySelector(".el-drawer__body").querySelector(".el-tabs__header")) {
            headTabHeight = document.documentElement.querySelector(".el-drawer__body").querySelector(".el-tabs__header").clientHeight
         }
         var leftTopHeight = 0
         var arr = document.documentElement.querySelector(".el-drawer__body").querySelector(".el-tabs__content").childNodes
         arr.forEach(item => {
            if (item.getAttribute("aria-hidden") != 'true') {
               leftTopHeight = item.querySelector('.leftTopForm').clientHeight
               floorHeight = item.querySelector('.foot').clientHeight
            }
         })
         this.boxHeight = totalHeight - headHeight - headTabHeight - 10 - floorHeight
         if (this.boxHeight - leftTopHeight <= this.boxHeight / 3) {
            this.leftBottomHeight = 300
         } else {
            this.leftBottomHeight = this.boxHeight - leftTopHeight - 75
         }
         if (this.sendDataInfo.leftTopObj.gchmType != 2) {
            if (this.boxHeight - leftTopHeight <= this.boxHeight / 3) {
               this.rightHeight = 300 + leftTopHeight - 60
            } else {
               this.rightHeight = this.boxHeight - 130

            }
         } else {
            this.rightHeight = 600
         }
         this.rightBoxHeight = this.boxHeight
         var boxWidth = document.documentElement.querySelector(".el-drawer__body").querySelector(".el-tabs__content").clientWidth
         document.documentElement.querySelector(".el-drawer__body").style = `padding-bottom:0px`
         if (boxWidth - 502 <= 500) {
            this.rightWidth = 500
         } else {
            this.rightWidth = boxWidth - 510
         }
      },
   },
   destroyed() {
      // 移除绑定的listenResizeFn事件监听
      window.removeEventListener("resize", this.heightChange);
   }
}
</script>

<style scoped>
.box {
   display: flex;
   overflow: auto;
}

.left {
   width: 500px;
   margin-right: 10px;
}

.content {
   display: inline-block;
   font-size: 14px;
}

::v-deep .el-table__body-wrapper {
   overflow: auto !important;
}

::v-deep .el-card__body {
   padding: 10px !important;
}

.uploadList {
   display: flex;
   align-items: center;
   flex-wrap: wrap;
}

.image {
   margin-right: 5px;
}

::v-deep .el-image__error {
   font-size: 7px;
}

.left ::v-deep .el-form-item {
   margin-bottom: 1px !important;
}

.rightBox {
   overflow: auto;
}
</style>